<template>
    <div class="table__body"
         :class="isHover ? 'with-hover' : ''"
         v-resize="resizeHandler"
    >
        <div
                v-for="(item, i) in tableBody"
                :key="i"
                class="table__row"
                :class="[[allowTooltip ? 'is-action' : ''], setIsExtended(item.tooltip)]"
                @click="moreHandler(item, i)"
        >
            <div
                    v-for="(column, name) in item"
                    :key="name"
                    :class="['table__row-item', getAdaptiveMode(name)]"
                    :style="{ 'flex-basis': getCurrentWidth(name) }"
            >
                <div v-if="name === 'gender'" class="table__row-item-gender">
                    <svg-icon :name="column ? 'male': 'female'"/>
                </div>

                <div class="table__row-text" v-else-if="name.includes('date')">
                    {{formatDate(column)}}
                </div>

                <div v-else-if="allowTooltip && name === lastItem">
                    <toggle :passCode="column"/>
                </div>

                <div class="table__row-text" v-else>
                    {{column}}
                </div>


            </div>
            <div v-if="actualMode || isMapOpen" class="table__row-item-more">
                <span class="table__row-item-more__arrow"></span>
            </div>
        </div>

    </div>
</template>

<script>
    import toggle from '@/elements/toggle';
    import table from "@/mixins/table";
    import formatDateMixin from "@/mixins/formatDateMixin";
    import {isUndefined} from '@/helpers/helpers'

    export default {
        components: {
            toggle,
        },

        mixins: [table, formatDateMixin],

        props: {
            tableBody: {
                type: Array,
                required: true,
            },
            tableHead: {
                type: Array,
                required: true,
            },
            isHover: {
                type: Boolean,
                default: false
            },
            allowTooltip: {
                type: Boolean,
                default: false
            },
            moreMode: {
                type: String,
                required: true,
            },
            isMapOpen: {
                type: Boolean,
                required: true,
            },
            tableData: {
                type: [Object, Array],
                required: false,
            }
        },

        mounted() {
            this.formatDate();
        },

        methods: {
            setIsExtended(tooltip) {
                if(!tooltip) return;
                if(isUndefined(tooltip.days_remaining) || isUndefined(tooltip.is_expired)) return;
                let {days_remaining, is_expired} = tooltip
                if(is_expired || !days_remaining) return 'is-error'
            },
            getCurrentWidth(name) {
                return this.tableHead.find(item => item.name === name).width
            },

            moreHandler(item, i) {
                if (this.isMapOpen && !this.actualMode) {
                    this.$router.push({ name: 'members-studio-page', params: { slug: this.tableData.data[i].slug, item: this.tableData.data[i] }})
                }

                if (this.actualMode) {
                    let type = this.isMapOpen ? 'map' : 'info';
                    this.$store.dispatch('SHOW_MODAL', {state: true, type: type, data: item, currentItemIndex: i})
                }
            }
        },
        computed: {
            lastItem() {
                let lastItem = this.tableHead[this.tableHead.length - 1];
                return lastItem.name
            },
        }
    }
</script>

<style lang="sass" scoped>
.table
    &__body
        &.with-hover
            .table__row
                cursor: pointer
                &:hover
                    border-color: transparent
                    background: #F0F5FE
    &__row
        display: flex
        justify-content: space-between
        align-items: center
        border-top: 1px solid rgba(1, 37, 78, 0.1)
        padding: 14px 12px
        background: transparent
        transition: background .3s ease, border-color .3s ease
        &.is-action
            .table__row-item
                &:last-of-type
                    text-align: center
                    overflow: unset
        &.is-error
            .table__row-text
                color: $color--red
            .icon-male,
            .icon-female
                stroke: $color--red
        &-text
            text-overflow: ellipsis
            white-space: nowrap
            overflow: hidden
        &-item
            font-size: $font-size--s
            text-overflow: ellipsis
            overflow: hidden
            white-space: nowrap
            letter-spacing: 0.01em
            +reg
            flex: 1
            flex-basis: 70px

            &-gender
                width: 33px
                height: 24px
                display: flex
                justify-content: center
                align-items: center

            &-more
                cursor: pointer

                &__arrow
                    cursor: pointer

                    &:before
                        content: ''
                        border: solid #8591A5
                        border-width: 0 1px 1px 0
                        padding: 5px
                        display: inline-block
                        transform: rotate(-45deg)
                        margin-left: -5px

            &.is-tablet
                +r(1023)
                    display: none

            &.is-mobile
                +r(767)
                    display: none
.icon-more
    width: 15px
    height: 9px

.icon-female, .icon-male
    stroke: #8591A5
</style>